import { render, staticRenderFns } from "./add-shipments.vue?vue&type=template&id=341b9990&scoped=true"
import script from "./add-shipments.vue?vue&type=script&lang=js"
export * from "./add-shipments.vue?vue&type=script&lang=js"
import style0 from "./add-shipments.vue?vue&type=style&index=0&id=341b9990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341b9990",
  null
  
)

export default component.exports